import { useQuery } from '@tanstack/react-query';

import * as LoyaltyService from '~/services/LoyaltyService';

import isUUID from '~/utils/isUUID';

export const loyaltyAccountQueryKeys = {
  all: ['loyalty-account'] as const,
  byCustomer: (customerId: string | null | undefined) => [...loyaltyAccountQueryKeys.all, customerId] as const,
};

export function useGetLoyaltyAccount(customerId: string | null | undefined, enabled = true) {
  const id = customerId ?? '';
  return useQuery({
    queryKey: loyaltyAccountQueryKeys.byCustomer(id),
    queryFn: () => LoyaltyService.getLoyaltyAccount(id),
    enabled: !!id && isUUID(id) && enabled,
    staleTime: 60_000,
    retry: false,
  });
}
